import { render, staticRenderFns } from "./PruebaDesarrollo.vue?vue&type=template&id=ed79f778"
import script from "./PruebaDesarrollo.vue?vue&type=script&lang=js"
export * from "./PruebaDesarrollo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports